import type { TitleMdProps } from "@circle-react-shared/uikit/Typography/components/Title/TitleMd";
import { Typography } from "@circle-react-uikit/Typography";

export const SidebarHeaderTitle = ({ children, ...rest }: TitleMdProps) => (
  <div className="py-0.5">
    <Typography.LabelMd weight="semibold" {...rest}>
      <span className="leading-7">{children}</span>
    </Typography.LabelMd>
  </div>
);
